import 'Onboarding/angularModule';
import angularDirectiveToReact from 'Angular2reactHelper';
import { useAngularToReactRoute } from 'Angular2reactHelper/useAngularToReactRoute';

const OnboardingHybridDirective = angularDirectiveToReact('onboardingHybridStart', {});

export function OnboardingHybridComponent() {
    const [key] = useAngularToReactRoute();
    return <OnboardingHybridDirective key={key} />;
}
